module.exports = __webpack_public_path__ + "img/57.61bdc503.png";